import { session, appState, EP, THU_IMIE, API_BASE } from '../config.js';
import { fmt } from '../format.js';
import { ICONS, hydrateIcons, svg } from '../icons.js';
import { lineChart } from '../chart.js';
import { DEMO, demoDay } from '../demo.js';
import { apiGet, apiPost, apiPut, noData, imieFor } from '../api.js';
import { C, spinner, emptyRow, toast } from '../ui.js';
import { closeModal } from '../modal.js';
import { go } from '../router.js';
import { applyRole, canDelete } from '../auth.js';
import { renderOpsRows, toolBtns, hintLine } from './operations.common.js';

export async function viewManual(plant){
  const scope=plant==='Shamshabad'?'sha':'thu';
  C().innerHTML=`<div class="panel"><div class="panel-head"><h2>Manual Operations — ${plant}</h2>
    <div class="btns">${toolBtns()}<button class="btn add" onclick="openAdd('${plant}')"><span data-icon="plus" data-size="16"></span>Add</button></div></div>
    <div class="panel-body" style="padding:0"><table><thead><tr><th>Date</th><th>Total Weight</th>${canDelete()?'<th>Actions</th>':''}</tr></thead>
    <tbody id="opsBody"><tr><td colspan="3">${spinner}</td></tr></tbody></table></div></div>${hintLine()}`;
  let rows=plant==='Thumkunta'?DEMO.manualThu:DEMO.manualSha;
  try{const r=await apiGet('GetApi.php',{ID:imieFor(plant),TableName:EP.manualList});const d=await r.json();if(!noData(d))rows=d.map(x=>[x.Date,Number(x['SUM(Weight)']??x.Total??0)])}catch(e){appState.OFFLINE=true;applyRole()}
  renderOpsRows(scope,plant,imieFor(plant),rows);
}

export function openAdd(plant){
  document.getElementById('modalRoot').innerHTML=`
   <div class="modal-overlay" onclick="if(event.target===this)closeModal()"><div class="modal-center">
    <div class="mhead"><h2>Add Manual Entry — ${plant}</h2><button class="xclose" onclick="closeModal()" data-icon="close" data-size="20"></button></div>
    <div class="mbody"><div class="form-grid">
      <div class="field"><label>Weight (Tonnes)</label><input type="number" id="mWeight" min="0" step="0.001" placeholder="e.g. 175.000"></div>
      <div class="form-row2"><div class="field"><label>From Date</label><input type="date" id="mDate"></div>
        <div class="field"><label>Time</label><input type="time" id="mTime" value="06:45"></div></div>
      <div class="err" id="mErr"></div>
      <div class="modal-foot"><button class="btn-cancel" onclick="closeModal()">Cancel</button>
      <button class="btn-save" id="mSave" onclick="saveManual('${plant}')">Save</button></div>
    </div></div></div></div>`;
  ICONS.close='<path d="M18 6 6 18"/><path d="m6 6 12 12"/>';hydrateIcons(document.getElementById('modalRoot'));
  document.getElementById('mDate').valueAsDate=new Date();
}

export async function saveManual(plant){
  const w=document.getElementById('mWeight').value,d=document.getElementById('mDate').value,t=document.getElementById('mTime').value,err=document.getElementById('mErr');
  if(!w||+w<=0){err.textContent='Please enter a valid weight greater than 0.';return}
  if(!d){err.textContent='Please select a date.';return}
  const table=plant==='Thumkunta'?'LoadConveyorDataTumukunta':'LoadConveyorData';
  document.getElementById('mSave').textContent='Saving…';
  try{await apiPost('PostApi.php',{ID:imieFor(plant),TableName:table},{Weight:w,FromDate:d,Time:(t||'06:45')+':00'});}catch(e){/* offline: just simulate */}
  closeModal();go(plant==='Thumkunta'?'manual-thu':'manual-sha');toast('Manual entry saved for '+plant);
}

/* DELETE OPERATION (unofficial) — DeleteShamshabad / DeleteTumukunta (date based) */
